module.exports = __webpack_public_path__ + "static/img/sye.1c31105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sye.png
// module id = 939m
// module chunks = 0